import React from 'react';
import '../../Styles/Projects/VideoModal.css';

const VideoModal = ({ url }) => {
    return (
        <div className="video-wrapper flex-box">
            <video controls src={url}></video>
        </div>
    )
}

export default VideoModal
